<template>
   <div class="row">
        <div class="col-12 col-md-12 acountStatus maxContainer economicCalendar">
        	<complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>	
            <message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component>
			<div class="mainTitle p-0 d-flex align-items-center justify-content-between text-center my-3" v-if="!pageLoader">
				<h3>{{$t('VPSList')}}</h3> 
                <router-link :to="{name: 'fxView.subscription_service_plan' , query: { 'id':6}}" class="btn_sm prism_btn " title="subscribe" data-placement="top"  data-toggle="tooltip">
				 {{$t('CreateNew')}}
				</router-link>
			</div>
            <div class="whiteBG pt-3 border supportpagetab radius mb-3"  v-if="vpsList.totalRecords > 0">
                <div class="mapIco-list-table">
                    <div class="tablePmm table-responsive">
                        <table class="table pmmTable" >
                            <thead>
                                <tr>
                                    <th>{{$t('ServerId')}}</th>
                                    <th>{{$t('Plan')}}</th>
									<th>{{$t('amount')}}</th>
                                    <th>{{$t('proMsz2')}}</th>
									<th>{{$t('Status')}}</th>
									<th>{{$t('type')}}</th>
                                    <th>{{$t('State')}}</th>
									<th>{{$t('action')}}</th>									
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(list,index) in vpsList.records">
                                    <td v-html="(list.server_id != '' && list.server_id != null)? list.server_id : '-'"></td>
                                    <td v-html="(list.name != '' && list.name != null)? list.name : '-'"></td>
									<td v-html="(list.amount != '' && list.amount != null)? list.amount : '-'"></td>
                                    <td >{{list.created | moment("DDDD DD MMMM YYYY")}}</td> 
									<td ><span class="badge badge-pill" :class="(list.detailed_state == 'active')?'badge-success' : 'badge-warning'">{{list.detailed_state}}</span></td>
									<td>-</td> 
                                    <td class="d-flex align-items-center"><span class="badge badge-pill badge-success stateStatus online mr-2"> <feather type="check"></feather></span> {{list.state}}</td>
									<td>
										<router-link :to="{name: 'fxView.vpsDetail' , query: { 'vps_id': list.id,'server_id' : list.server_id}}"  title="View" data-placement="top"  data-toggle="tooltip">
											{{$t('Manage')}} 
										</router-link>
										<a href="#" class="readload_server" @click="loadOnce()"><feather type="refresh-cw"></feather></a>
									</td>
                                </tr>
                            </tbody>
                        </table> 
                    </div>
                </div> 
				<pagination :getList="vpsList" :limit="pageLimit" v-if="vpsList.totalRecords > 15"></pagination>
            </div>
            <div class="whiteBG text-center border supportpagetab radius mb-3 p-5"  v-else-if="vpsList.totalRecords == 0">
            	<img src="../../../../static/fxView/images/server.svg" alt="Create new VPS" class="w-25">
				<p class="mb-3 f-15">
					{{$t('vpsMsz')}}
					<router-link :to="{name: 'fxView.subscription_service_plan' , query: { 'id':6}}" title="View" >
						Click Here
					</router-link>
					to create one.
				</p>
			</div>
			<div v-else class="text-center p-5 customLoader"> 
				
				<h4>{{$t('plzWaitWhileProc')}}</h4>
			</div>
        </div>
    </div>
</template>
<script> 
	import { fxViewMixins } from '@/plugins/fxView'
	import { Const } from '@/plugins/fxView/provider/candle-history/lib/const.cls'
	export default {
		name: 'Vps-list',
		mixins: [fxViewMixins],
		data() {
			return {
				//===========prop in loader component=======
				col_span : 5,
				//============message and loader ===========
				response_msg : '',
				msg_type : '',
				pageLoader : false,
				loaderFuncRun : '1',
				//==========================================
				pageLimit : '15',
				search : '',
				page : '1'
			}
		},
		methods:{
			loadOnce:function(){
				location.reload();
			},
			listing(){
				let inputJson = {
					'globalParams' : {
						filter: {},
						sort: [],
						search: this.search,
						page: this.page,
						perPage: parseInt(this.pageLimit),
					} ,'localParams' : {'parameter' : this , 'loaderFuncRun' : this.loaderFuncRun}
				}
				this._runGetVpsList(inputJson)
			}
		},
		created(){
			if(this.$store.getters[Const.GET_VPS_LIST] != ''){
				this.loaderFuncRun = '0'
			}
			this.listing()
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/fxView/tradingtools/vpsList.vue